import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import LearningStreamWriterForm from '../forms/learning-stream-writer-form';
import { learningStreamWriterValidationSchema } from '../schema/learningStreamWriter.js';

export default function LearningStreamWriterNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Learning Stream Writer Node Details',
        altText: 'Learning Stream Writer Node',
        defaultLabel: 'Learning Stream Writer Node',
      }}
    >
      <CommonNode
        FormComponent={LearningStreamWriterForm}
        schemaResolver={learningStreamWriterValidationSchema}
      />
    </NodeProvider>
  );
}
